import { useEffect, useRef, useState } from 'react'

/**
 * Debounces a string value by the specified delay.
 * Useful for search inputs where API calls should wait until typing pauses.
 */
export const useDebouncedValue = (value: string, delayMs: number): string => {
  const [debouncedValue, setDebouncedValue] = useState(value)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    timerRef.current = setTimeout(() => setDebouncedValue(value), delayMs)
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [value, delayMs])

  return debouncedValue
}
